var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "action-panel-anchor" }, [
    _c("div", {
      staticClass: "action-panel-anchor__slot",
      attrs: { "aria-hidden": "true" },
    }),
    _c("section", { staticClass: "action-panel" }, [
      _c("div", { staticClass: "action-panel__header" }, [
        _c("p", { staticClass: "action-panel__title" }, [
          _vm._v(_vm._s(_vm.$t("assistantCatHome.actions.title"))),
        ]),
        _c(
          "button",
          {
            staticClass: "action-panel__toggle",
            attrs: {
              type: "button",
              "aria-expanded": _vm.expanded ? "true" : "false",
              "aria-label": _vm.expanded
                ? _vm.$t("assistantCatHome.actions.collapse")
                : _vm.$t("assistantCatHome.actions.expand"),
            },
            on: {
              click: function ($event) {
                _vm.expanded = !_vm.expanded
              },
            },
          },
          [_vm.expanded ? _c("icon-minimize") : _c("icon-maximize")],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "action-panel__viewport",
          class: { "is-expanded": _vm.expanded },
        },
        [
          _c(
            "div",
            { staticClass: "action-panel__chips" },
            [
              _vm.expanded
                ? _vm._l(_vm.chipActions, function (action) {
                    return _c(
                      "button",
                      {
                        key: action,
                        staticClass: "action-panel__chip",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("action", action)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(`assistantCatHome.actions.${action}`)
                            ) +
                            " "
                        ),
                      ]
                    )
                  })
                : _vm._l(_vm.collapsedChipRows, function (row, rowIndex) {
                    return _c(
                      "div",
                      { key: rowIndex, staticClass: "action-panel__row" },
                      _vm._l(row, function (action) {
                        return _c(
                          "button",
                          {
                            key: action,
                            staticClass: "action-panel__chip",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("action", action)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(`assistantCatHome.actions.${action}`)
                                ) +
                                " "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  }),
            ],
            2
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }